import React, { useState } from "react";
import {
  Form,
  FormGroup,
  InputGroup,
  InputGroupText,
  Input,
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import PageLayout from "../PageLayout";
import { useNavigate } from "react-router-dom";
import { forgetPasswordApi } from "src/network/api";
import { toast } from "react-toastify";

interface EmailFormData {
  email: string;
}

const ForgetPassword: React.FC = () => {
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<EmailFormData>({
    mode: "onChange",
  });

  const navigate = useNavigate();
  const onSubmit: SubmitHandler<EmailFormData> = async (data) => {
    try {
      setIsProcessing(true);
      let response = await forgetPasswordApi(data.email);
      if (response.status == 200 && response.data?.status == 200) {
        toast.success(response.data.message);
        navigate("/");
        reset();
      } else {
        toast.error(response.data?.message);
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleNavigation = () => {
    navigate("/password-reset");
  };

  return (
    <PageLayout>
      <Container>
        <Row className="justify-content-center m-5">
          <Col lg="6" md="8" sm="10">
            <Card
              className="shadow border-0"
              style={{
                borderRadius: "15px",
                marginTop: "2rem",
              }}
            >
              <CardHeader
                className="text-white text-center"
                style={{
                  backgroundColor: "#5e72e4",
                  borderRadius: "15px 15px 0 0",
                  padding: "1rem",
                }}
              >
                <p style={{ fontSize: "1.5rem", margin: "0" }}>
                  Forget Password
                </p>
              </CardHeader>
              <CardBody>
                <Form role="form" onSubmit={handleSubmit(onSubmit)}>
                  <FormGroup>
                    <InputGroup className="input-group-alternative">
                      <InputGroupText>
                        <i className="ni ni-email-83 text-primary" />
                      </InputGroupText>
                      <Controller
                        name="email"
                        control={control}
                        rules={{
                          required: "Email is required",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: "Invalid email",
                          },
                        }}
                        render={({ field }) => (
                          <Input
                            {...field}
                            placeholder="Registered Email"
                            type="email"
                          />
                        )}
                      />
                    </InputGroup>
                    {errors.email && (
                      <div
                        className="error-text"
                        style={{ fontSize: "0.8rem" }}
                      >
                        {String(errors.email?.message)}
                      </div>
                    )}
                  </FormGroup>
                  <div className="text-center">
                    <Button
                      className="btn-lg"
                      color="primary"
                      type="submit"
                      disabled={isProcessing}
                      style={{
                        backgroundColor: "#5e72e4",
                        borderRadius: "50px",
                        padding: "0.8rem 2rem",
                        fontSize: "1rem",
                      }}
                    >
                      {isProcessing ? "Please wait..." : "Submit"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </PageLayout>
  );
};

export default ForgetPassword;
